<template>
    <breadCrumbs title="Default Dashboard" main="Dashboard" title1="default" />


    <div class="container-fluid default-page">
        <div class="row">
            <div class="col-xl-5 col-lg-5">
                <div class="card profile-greeting">
                    <div class="card-body">
                        <div>
                            <h1>Welcome,William</h1>
                            <p> You have completed 40% of your this week! Start a new goal & improve your result</p>
                            <router-link class="btn" to="/users/profile">Continue<vue-feather
                                    type="arrow-right"></vue-feather></router-link>
                        </div>
                        <div class="greeting-img"><img class="img-fluid"
                                src="@/assets/images/dashboard/profile-greeting/bg.png" alt=""></div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-md-6 col-lg-3">
                <div class="card yearly-view">
                    <div class="card-header pb-0">
                        <h3>Yearly Overview<span class="badge badge-primary">50/100</span></h3>
                        <h5 class="mb-0">Monday</h5>
                    </div>
                    <yearlyOverview />

                </div>
            </div>
            <activityPage />
            <transactionPage />
            <salesPage />
            <linePage />
            <investPage />
            <socialPage />
            <div class="col-xl-4 col-md-6 box-col-50 des-xl-50">
                <div class="card upgrade-history">
                    <div class="card-body">
                        <div>
                            <h3>Buy more space now! </h3>
                            <p>Invite 2 Friends and get 5 GB extra space.</p><a class="btn btn-primary"
                                href="https://themeforest.net/user/pixelstrap/portfolio" target="_blank"> Upgrade now</a>
                        </div>
                    </div>
                    <div class="upgrade-img"><img class="img-fluid" src="@/assets/images/dashboard/upgrade/1.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import yearlyOverview from './yearlyOverview.vue'
import activityPage from './activityPage.vue'
import transactionPage from './transactionPage.vue'
import salesPage from './salesPage.vue'
import linePage from './linePage.vue'
import investPage from './investPage.vue'
import socialPage from './socialPage.vue'
export default {
    name: 'indexDefault',
    components: {
        yearlyOverview,
        activityPage,
        transactionPage,
        salesPage,
        linePage, investPage, socialPage
    }
}

</script>
